const quotationChat = {
  quotationChatNavLabel: "Pasiūlymo pokalbis", // translated 
  quotationChatApprovalTitle: "Pasiūlymo pokalbis", // translated 
  quotationChatAccountNotApprovedTitle: "Paskyra nepatvirtinta", // translated 
  quotationChatAccountNotApprovedDescription:
    "Jūsų reikalavimas dar nepatvirtinta. Dėl papildomo susisiekite su savo informacijos vadybininku.", // translated 
  quotationChatViewAiChat: "Peržiūrėti DI pokalbį", // translated 
  quotationRequestChatSessions: "Pokalbių sesijos", // translated 
  quotationRequestChatNoPastSessions: "Nėra ankstesnių sesijų", // translated 
  quotationRequestChatNewChat: "Naujas pokalbis", // translated 
  quotationRequestChatCloseSidebar: "Uždaryti šoninį meniu", // translated 
  quotationRequestChatSessionFallback: "Pokalbio sesija", // translated 
  quotationRequestChatDefaultSessionName: "Nauja pokalbio sesija", // translated 
  quotationRequestChatTitle: "Pasiūlymo užklausos pokalbis", // translated 
  quotationRequestChatResponseLanguageLabel: "Atsakymo kalba", // translated 
  quotationRequestChatOpenSidebar: "Atidaryti šoninį meniu", // translated 
  quotationRequestChatRenameSession: "Pervardyti sesiją", // translated 
  quotationRequestChatDeleteSession: "Ištrinti sesiją", // translated 
  quotationRequestChatToggleDarkMode: "Perjungti tamsųjį režimą", // translated 
  quotationRequestChatSwitchToLightMode: "Perjungti į šviesųjį režimą", // translated 
  quotationRequestChatSwitchToDarkMode: "Perjungti į tamsųjį režimą", // translated 
  quotationRequestChatEmptyStateHeading: "Pradėkite naują pasiūlymą užklausos pokalbį", // translated 
  quotationRequestChatEmptyStateSubheading:
    "Aprašyk savo kelionės poreikius ir aš sukursiu pasiūlymo užklausą.", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "Įveskite, kad pradėtumėte pokalbį... (Shift+Enter naujai eilutei)", // translated 
  quotationRequestChatMessagePlaceholder:
    "Įveskite kalbater... (Shift+En naujai eilutei)", // translated 
  quotationRequestChatUploadFile: "Įkelti failą", // translated 
  quotationRequestChatUploadAttachment: "Įkelti priedą", // translated 
  quotationRequestChatStopGenerating: "Sustabdyti generavimą", // translated 
  quotationRequestChatGenerateQuotation: "Generuoti pasiūlymą", // translated 
  quotationRequestChatGenerateFinalQuotation: "Generuoti galutinį pasiūlymą", // translated 
  quotationRequestChatFinalizeQuotationRequest: "Užbaigti pasiūlymo užklausą", // translated 
  quotationRequestChatHoldToRecord: "Laikykite, kad užsimanėte balso dalyvauti", // translated 
  quotationRequestChatRecordingReleaseToSend: "Įrašoma, atleiskite, kad nereikia", // translated 
  quotationRequestChatRecording: "Įrašoma...", // translated 
  quotationRequestChatSelectSessionFirst: "pirmiausia pasirinkite pokalbio sesiją.", // translated 
  quotationRequestChatCancelVoiceRecording: "Atšaukti balso įrašą", // translated 
  quotationRequestChatListening: "Klausoma...", // translated 
  quotationRequestChatTranscribing: "Transkribuojama...", // translated 
  quotationRequestChatFileUploadedSuccess: "Failas sėkmingai įkeltas.", // translated 
  quotationRequestChatUnsupportedFileType: "Nepalaikomas failo tipas. Įkelkite PDF, Word (.docx), Excel (.xlsx), PowerPoint (.pptx), tekstą/CSV arba paveikslėlį.", // translated
  quotationRequestChatFailedCreateSession: "Nepavyko sukurti pokalbio sesijos. Bandykite dar kartą.", // translated 
  quotationRequestChatFailedUploadFile: "Nepavyko įkelti failo. Bandykite dar kartą.", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "Prieš siųsdami kitus atsakykite į laukiančius klausimus.", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "Prieš užbaigdami pasiūlymo užklausą atsakykite į laukiančius klausimus.", // translated 
  quotationRequestChatFavoriteMarked: "Pokalbio sesija pažymėtia kaip mėgstama", // translated 
  quotationRequestChatFavoriteUnmarked: "Pokalbio sesija nebepažymėta kaip mėgstama", // translated 
  quotationRequestChatFailedSetFavorite: "Nepavyko pažymėti kaip mėgstamą", // translated 
  quotationRequestChatFailedUnsetFavorite: "Nepavyko pašalinti iš mėgstamų", // translated 
  quotationRequestChatRenamedSuccess: "Pokalbio sesija sėkmingai pervardyta.", // translated 
  quotationRequestChatFailedRename: "Nepavyko pervardyti pokalbio sesijos. Bandykite dar kartą.", // translated 
  quotationRequestChatDeletedSuccess: "Pokalbio sesija sėkmingai ištrinta.", // translated 
  quotationRequestChatFailedDelete: "Nepavyko kalbėti pokalbio sesijos. Bandykite dar kartą.", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "Priedas sėkmingai ištrintas.", // translated 
  quotationRequestChatFailedDeleteAttachment: "Nepavyko priedo. Bandykite dar kartą.", // translated 
  quotationRequestChatSubmittedSuccess:
    "Pasiūlymo užklausa sėkmingai pateikta! Jūsų užklausa apdorojama.", // translated 
  quotationRequestChatFailedSubmit: "Nepavyko pateikti pasiūlymo užklausos", // translated 
  quotationChatPdfDownloadedSuccess: "PDF sėkmės atsisiuntimas!", // translated 
  quotationChatFailedGeneratePdf: "Nepavyko sugeneruoti PDF", // translated 
  quotationRequestChatSubagentRequired:
    "Prieš pateikdami pasiūlymo užklausą pasirinkti subagentą.", // translated 
  quotationRequestChatAppUserLoading:
    "Jūsų CRM programos naudotojo profilis vis dar įkeliamas. Bandykite po akimirkos.", // translated 
  quotationRequestChatAppUserMismatch:
    "Jūsų CRM programos naudotojo profilis nepastebėtas pokalbio sesijos.", // translated 
  quotationRequestChatRenameTitle: "Pervardyti pokalbio sesiją", // translated 
  quotationRequestChatSessionName: "Sesijos pavadinimas", // translated 
  quotationRequestChatEnterSessionName: "Įveskite sesijos pavadinimą", // translated 
  quotationRequestChatSaving: "Išsaugoma...", // translated 
  quotationRequestChatSave: "Išsaugoti", // translated 
  quotationRequestChatDeleteTitle: "Ištrinti pokalbio sesiją", // translated 
  quotationRequestChatDeleteConfirm: "Ar tikrai norite šią pokalbio sesiją?", // translated 
  quotationRequestChatDeleteCannotUndo: "Šio veiksmo negalima atšaukti.", // translated 
  quotationRequestChatDeleting: "Trinama...", // translated 
  quotationRequestChatDelete: "Ištrinti", // translated 
  quotationRequestChatAttachmentsTitle: "Pasiūlymo užklausos pokalbio priedai", // translated 
  quotationRequestChatLoadingAttachments: "Įkeliami priedai...", // translated 
  quotationRequestChatNoAttachments: "Priedų nerasta", // translated 
  quotationRequestChatDeleteAttachment: "Ištrinti priedą", // translated 
  quotationRequestChatUploadingAttachment: "Įkeliamas priedas...", // translated 
  quotationRequestChatUploadingAttachmentWait:
    "Palaukite, kol failas bus įkeltas.", // translated 
  quotationRequestChatAnswerPendingQuestions: "Atsakyti į laukiančius klausimus", // translated 
  quotationRequestChatProposeOwnAnswer: "Pasiūlyti savo atsakymą", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "Įveskite savo atsakymą...", // translated 
  quotationRequestChatAnsweredOfTotal: "Atsakyta {{atsakyta}} iš {{viso}}", // translated 
  quotationRequestChatReadyToSubmit: "Paruošta pateikti", // translated 
  quotationRequestChatSubmitAll: "Pateikti viską", // translated 
  quotationRequestChatRespondToOneQuestion: "Atsakyti į {{count}} klausimą", // translated 
  quotationRequestChatRespondToManyQuestions: "Atsakyti į {{count}}klausimus", // translated 
  quotationRequestChatFinalizeTitle: "Užbaigti pasiūlymo užklausą", // translated 
  quotationRequestChatLoadingSessionData: "Įkeliami sesijos duomenys...", // translated 
  quotationRequestChatErrorLoadingSession: "Klaida įkeliant sesijos duomenis. Bandykite dar kartą.", // translated 
  quotationRequestChatQuotationTitle: "Pasiūlymo pavadinimas", // translated 
  quotationRequestChatExtraComments: "Papildomi komentarai", // translated 
  quotationRequestChatSubmitting: "Pateikiama...", // translated 
  quotationRequestChatSubmit: "Pateikti", // translated 
  quotationRequestChatSubmittingOverlayTitle: "Pateikiama pasiūlymo užklausa...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "Palaukite, kol jūsų pasiūlymo užklausa bus pateikta.", // translated 
  quotationRequestChatSelectSubagent: "Pasirinkti subagentą", // translated 
  quotationRequestChatSearchSubagents: "Ieškokite subagentų...", // translated 
  quotationRequestChatLoadingSubagents: "Įkeliami subagentai...", // translated 
  quotationRequestChatNoSubagentsFound: "Subagentų nerasta", // translated 
  quotationRequestChatNoSubagentsAvailable: "Subagentų nėra", // translated 
  quotationRequestChatSelectedSubagent: "Pasirinkti: {{label}}", // translated 
  quotationRequestChatSubagentUsers: "Subagentų naudotojai", // translated 
  quotationRequestChatSearchUsers: "Ieškokite naudotojų...", // translated 
  quotationRequestChatNoUsersFound: "Naudotojų nerasta", // translated 
  quotationRequestChatNoUsersAvailable: "Naudotojų nėra", // translated 
  quotationChatDownloadSummaryTitle: "Atsi pasiūlymo santrauką", // translated 
  quotationChatDownloadSummaryDescription:
    "Užpildykite savo duomenis žemiau, kad sugeneruotumėte personalizuotą kelionės pasiūlymą PDF santrauką. PDF apims visą kelionės informaciją, vietas, transportą ir dienos planą.", // translated 
  quotationChatCustomerTitle: "Kreipinys", // translated 
  quotationChatSelectTitle: "Pasirinkite kreipinį", // translated 
  quotationChatHonorificMr: "Gerb.", // translated 
  quotationChatHonorificMrs: "Gerb. p.", // translated 
  quotationChatHonorificMs: "Gerb. p.", // translated 
  quotationChatHonorificDr: "Dr.", // translated 
  quotationChatHonorificProf: "Profesorius", // translated 
  quotationChatCustomerPhone: "Telefonas", // translated 
  quotationChatCustomerCompany: "Įmonė", // translated 
  quotationChatCustomerMessage: "Žinutė", // translated 
  quotationChatCustomerCountry: "Šalis", // translated 
  quotationChatGenerating: "Generūjama...", // translated 
  quotationChatDownloadPdf: "Atsisiųsti PDF", // translated 
  quotationChatTripSummary: "Kelionės santrauka", // translated 
  quotationChatDownloadAsPdf: "Atsisiųsti kaip PDF", // translated 
  quotationChatNoTripSummary: "Šiaulių sesijų kelionės santrauka nepasiekiama.", // translated 
  quotationRequestChatThinking: "Galvojama...", // translated 
  quotationRequestChatSources: "Šaltiniai", // translated 
  quotationRequestChatSearchingWebFor: 'Ieškoma internete: "{{query}}"...', // translated 
  quotationRequestChatServicesByTourOperator: "Kelionių organizatoriaus vykdomos paslaugos", // translated 
  quotationRequestChatServicesByCustomer: "Kliento tvarkomos paslaugos", // translated 
  quotationRequestChatReadyNotice:
    "Dabar galite pasiūlyti šiai užklausai paspaudę dešinėje esantį sultinį.", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "Generuoti galutinį pasiūlymą", // translated 
  quotationRequestChatMaybeYouWantToAsk: "Gal nori paklausti:", // translated 
  quotationRequestChatClickToSendSuggestion: "Spausk, kad reikia šią problemą", // translated 
  quotationRequestChatAddToFavorites: "Pridėti į malonumą", // translated 
  quotationRequestChatRemoveFromFavorites: "Pašalinti iš mėgstamiausių", // translated 
  quotationRequestChatSubmitted: "Pateikta", // translated 
  quotationRequestChatQuotationRequest: "Pasiūlymo užklausa: {{nuoroda}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{title}}", // translated 
  quotationRequestChatQuotationTooltipStatus: "- Būsena: {{status}}", // translated 
  quotationChatLoading: "Įkeliama...", // translated 
  quotationChatSessionNotFound: "Šiam pasiūlymui pokalbio sesija nerasta", // translated 
  quotationChatMemberSessionNotFound: "Jūsų reikalai nario sesija nerasta", // translated 
  quotationChatUnableToConnect: "Nepavyko prisijungti prie pokalbio", // translated 
  quotationChatConnecting: "Jungiamasi...", // translated 
  quotationChatTypeYourMessage: "įveskite žinutę...", // translated 
  quotationChatConnected: "Prisijungta", // translated 
  quotationChatConnectingStatus: "Jungiamasi...", // translated 
  quotationChatDisconnected: "Atsijungta", // translated 
};


export default quotationChat;
